// Pill — boards ToileDocked / CellStates arrival row, verbatim values.

.wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 22px;
    z-index: var(--tl-z-pill);
    display: flex;
    justify-content: center;
    pointer-events: none;
}

.pill {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--tl-surface);
    border: 1px solid color-mix(in srgb, var(--tl-accent) 45%, transparent);
    border-radius: var(--tl-radius-pill);
    padding: 8px 10px 8px 12px;
    box-shadow: 0 0 26px color-mix(in srgb, var(--tl-accent) 12%, transparent), 0 18px 44px color-mix(in srgb, var(--tl-shadow-ink) 55%, transparent);
    backdrop-filter: blur(14px);
    position: relative;
    overflow: hidden;
}

.live::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 38%;
    background: color-mix(in srgb, var(--tl-accent) 90%, transparent);
}

// One slot, at its picture's own ratio: 44 px tall, the width set inline (`pillSlotWidth`, 30-58).
// `container-type` so the cell at work it may carry sizes against the slot, as it does in a tile.
.slot {
    position: relative;
    flex: none;
    height: 44px;
    border-radius: var(--tl-radius-art-lg);
    overflow: hidden;
    display: block;
    border: 1px solid var(--tl-border-strong);
    background: var(--tl-stage);
    container-type: inline-size;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

// `N ready` — the accent ring the root slot carried before, with its glow.
.ring {
    border-color: transparent;
    box-shadow: 0 0 0 1px color-mix(in srgb, var(--tl-accent) 70%, transparent),
        0 0 12px color-mix(in srgb, var(--tl-accent) 35%, transparent);
}

.dashed {
    border: 1px dashed color-mix(in srgb, var(--tl-accent) 40%, transparent);
    background: none;
}

// The whole pill as the target, outside `N ready`: a transparent cover under the × only.
.hit {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

// Where Continue ↑ stands when it is not shown: the mono register, muted.
.chevron {
    font-family: var(--tl-font-label);
    font-size: 13px;
    color: var(--tl-dim);
    padding: 0 6px;
}

.label {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
}

.name {
    font-family: var(--tl-font);
    font-size: 13px;
    color: var(--tl-text);
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
}

// Colour and case are the Notice component's job now (`@core/ui/Notice`) — this class carries
// position/type only.
.state {
    margin: 0;
    font-family: var(--tl-font-label);
    font-size: 9.5px;
    letter-spacing: 0.14em;
    white-space: nowrap;
}

.continueBtn {
    background: var(--tl-accent);
    color: var(--tl-accent-ink);
    font-family: var(--tl-font);
    font-weight: 500;
    font-size: 13px;
    padding: 9px 17px;
    border: none;
    border-radius: var(--tl-radius-pill);
    white-space: nowrap;
    box-shadow: 0 0 24px color-mix(in srgb, var(--tl-accent) 35%, transparent);
    cursor: pointer;
}

.close {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    flex: none;
    background: none;
    border: none;
    color: var(--tl-dim);
    cursor: pointer;
}
